import { mapMutations, mapActions } from "vuex";

export default {
    methods: {
        ...mapMutations('alert', [
            'clearNotes',
        ]),

        ...mapActions('alert', [
            'addErrorMessage',
            'addInfoMessage',
        ]),

        addResponseMessage (response) {
            if (response.status === 'success') {
                if (response.message) {
                    this.addInfoMessage(response.message);
                }
            } else if (response.message) {
                this.addErrorMessage(response.message);
            } else {
                this.addErrorMessage('Неизвестная ошибка');
            }
        }
    }
}
